<template>
  <div class="summary-product-card">
    <b-card
      :title="summaryTitle()"
      :sub-title="cartItem.product.supportingText"
      class="summaryTitle"
    >
      <b-card-text>
        <div class="row">
          <div class="col-7">
            <div class="form-group">
              <select
                class="form-control mt-3 input-field variant-select"
                v-model="selectedVariant"
                @change="optionChanged"
              >
                <option
                  v-for="v in cartItem.product.variants"
                  :key="v.articleId"
                  :value="v.articleId"
                >
                  <div v-if="cartItem.product.isBundle">{{ v.title }}</div>
                  <div v-else>{{ v.title }} / {{ v.price | toCurrency }}</div>
                </option>
              </select>
              <span v-if="cartItem.product.variants.length > 1">
                <img src="@/assets/chevron-down.svg" class="arrow-icon" />
              </span>
            </div>
          </div>
          <div class="col-5 mt-3">
            <div class="row pt-2">
              <div class="rounded-numberpicker mx-auto" style="width: 105px">
                <number-input
                  v-model="quantity"
                  :min="0"
                  :max="10"
                  inline
                  controls
                ></number-input>
              </div>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SummaryProductCard",
  components: {},
  props: {
    cartItem: Object,
  },
  data() {
    return {
      selectedVariant: "",
      quantity: 0,
    };
  },
  mounted() {
    this.selectedVariant = this.cartItem.variant.articleId;
    this.quantity = this.cartItem.quantity;
  },
  updated() {},
  computed: {
    ...mapGetters(["cartIsEmpty"]),
  },
  methods: {
    optionChanged: function () {
      if (this.quantity > 0) {
        this.addToCart();
      }
    },
    addToCart: function () {
      let variant = this.cartItem.product.variants.find(
        (x) => x.articleId === this.selectedVariant
      );
      let cartObj = {};
      cartObj.product = this.cartItem.product;
      cartObj.variant = variant;
      cartObj.quantity = this.quantity;
      this.selectedVariantObj = variant;
      this.$store.dispatch("addToCart", cartObj);
    },
    summaryTitle: function () {
      if (!this.cartItem.product.isBundle) {
        return this.cartItem.product.title;
      } else {
        let bundleTitle =
          this.cartItem.product.title +
          "\n" +
          (this.cartItem.variant.size || this.cartItem.variant.title) +
          " / " +
          "\u00A3" +
          this.cartItem.variant.price;
        return bundleTitle;
      }
    },
  },
  watch: {
    quantity: function (val, preVal) {
      if (preVal === 0) {
        this.addToCart();
        if (this.$gtag){
          this.$gtag.event("Add to Basket", {
            event_category: "Food to Order",
            event_label: this.cartItem.product.title,
          });
        }
      }
      else if (val > 0) {
        this.addToCart()
        if (this.$gtag) {
          this.$gtag.event('Quantity Changed', {
            'event_category': 'Food to Order',
            'event_label': this.product.title
          })
        }
      }
       else {
        this.$store.dispatch("removeFromCart", this.cartItem.product);
        if (this.$gtag) {
          this.$gtag.event('Remove from Basket', {
            'event_category': 'Food to Order',
            'event_label': this.cartItem.product.title
          })
        }
      }

      if (this.cartIsEmpty()) {
        this.$router.push({ path: "/" });
      }
    },
  },
};
</script>

<style lang="scss">
.card-title {
  font-size: 18px;
  color: #0f0f0f;
  font-weight: 300;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.card-body {
  padding: 30px;
}
.card-subtitle {
  font-size: 14px;
  font-weight: 300;
  color: #757575;
}
.variant-select {
  height: 45px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 25px;
}
.important-info {
  font-size: 14px;
  font-weight: 300;
  padding-top: 21px;
  color: #424242;
}
.more-details {
  line-height: 1.5;
  font-weight: 300;
}
.card-deck .card {
  margin-bottom: 0;
}
.summary-product-card {
  width: 100%;
  margin-bottom: 0;
  @include media(">sm") {
    width: 50%;
    margin-bottom: 15px;
  }
}
.summaryTitle {
  white-space: pre;
}
</style>
